import { groupBy, mapValues, sumBy } from 'lodash-es'

import { PremiumItemBreakdownLine } from './types'

export const getBreakdownLine = (items: PremiumItemBreakdownLine[], codes?: string[]) => {
  const filtered = codes
    ? items
        .filter((item) => codes.includes(item.code))
        .sort((a, b) => codes.indexOf(a.code) - codes.indexOf(b.code))
    : items

  const grouped = groupBy(filtered, (it) => it.code)
  return mapValues(grouped, (items) =>
    Math.abs(sumBy(items, (it) => it.grossPremiumInclTaxAmt)),
  )
}
